import React from 'react'
import classSet from 'react-classset'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import Spinner from '../../Spinner.jsx'
import FlatButton from '../../FlatButton.jsx'
import { LOGIN_REQUST, loginRequest, LOGIN_REDIRECT } from '../../../state/login/loginActions'
import { getLogin } from '../../../state/login/loginReducer'
import { clear } from '../../../state/progress/progressActions'
import styles from './LoginPage.scss'

const mapStateToProps = (state) => {
  const { progress: { pending, error } } = state
  return {
    authenticationPending: pending[LOGIN_REQUST],
    isRedirecting: pending[LOGIN_REDIRECT],
    authenticationError: error[LOGIN_REQUST],
    isAuthenticated: getLogin(state).isAuthenticated
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    login: (login, password) => dispatch(loginRequest(login, password)),
    clearLoginError: () => dispatch(clear(LOGIN_REQUST))
  }
}

export class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      login: '',
      password: '',
      isRedirecting: false
    }
  }
  componentDidMount() {
    document.body.className = styles.body
  }
  componentDidUnMount() {
    document.body.className = styles.body
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isRedirecting && !prevState.isRedirecting) {
      return { isRedirecting: true }
    }
    return null
  }

  render() {
    const { login, authenticationError, authenticationPending, clearLoginError } = this.props
    const { isRedirecting } = this.state
    const handleStateChange = (prop, value) => {
      clearLoginError()
      this.setState((prevState, props) => {
        const newState = Object.assign({}, prevState)
        newState[prop] = value
        return newState
      })
    }

    return <div className={styles.login}>
      <h1>COMTAX<p>TAX NAVIGATOR</p></h1>
      <div>
        <label>
          <input className={classSet({ [styles.errorInput]: authenticationError })}
            ref={(input) => {
              this.refUserInput = input
              if (this.refUserInput && this.state.login !== this.refUserInput.value) {
                handleStateChange('login', this.refUserInput.value)
              }
            }}
            onChange={(event) => handleStateChange('login', event.target.value)}></input>
        </label>
        <label>
          <input type='password' className={classSet({ [styles.errorInput]: authenticationError })}
            ref={(input) => {
              this.refPasswordInput = input
              if (this.refPasswordInput && this.state.password !== this.refPasswordInput.value) {
                handleStateChange('password', this.refPasswordInput.value)
              }
            }}
            onChange={(event) => handleStateChange('password', event.target.value)} ></input>
        </label>
        <strong className={styles.errorMessage}>{authenticationError && authenticationError.reason}</strong>
        <div>
          <Spinner waitFor={isRedirecting}>
            <FlatButton disabled={!this.state.login || authenticationError || authenticationPending} onClick={
              () => login(this.state.login, this.state.password)
            }>Log in</FlatButton>
          </Spinner>
        </div>
      </div>
    </div>
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)

LoginPage.propTypes = {
  login: PropTypes.func,
  authenticationError: PropTypes.object,
  authenticationPending: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isRedirecting: PropTypes.bool,
  clearLoginError: PropTypes.func
}
